<template>
  <div id="option-groups">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main v-if="dataReady">
      <!-- modal congestion situation -->
      <!-- menu detail -->
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60">
          <div class="l-main__head">
            <div v-on:click="backPagePrevious" class="l-main__head--control l-main__head--control--back">
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="">
            </div>
            <div class="l-main__head--title">詳細</div>
            <a href="#" class="l-main__head--control">
            </a>
          </div>
          <div class="l-menu-detail">
            <!-- banner -->
            <div class="c-banner c-banner--menu mb-0">
              <!-- Swiper -->
              <div class="swiper-container c-banner__swiper js-banner-swiper" ref="jsBannerSwiper">
                <div class="swiper-wrapper">
                  <div v-for="(img, index) in product.image" :key="index" class="product-image swiper-slide js-keep-ratio" data-ratio="0.8220858896">
                    <img v-bind:src="getImgSrc(img)" alt="" :data-hash="`image_${index}`">
                  </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
              </div>
            </div>
            <div class="handling-labels">
              <span class="handling-format-label togo" v-if="type == 'pickup' && acceptableHandlingFormats.includes(1) && handlingFormats.includes(1)">お持ち帰り</span>
              <span class="handling-format-label forhere" v-if="type == 'pickup' && acceptableHandlingFormats.includes(2) && handlingFormats.includes(2)">店内でお食事</span>
              <span class="handling-format-label drivethru" v-if="type == 'drivethru' && acceptableHandlingFormats.includes(3) && handlingFormats.includes(3)">ドライブスルー</span>
              <span class="handling-format-label parkandpickup" v-if="type == 'parkandpickup' && acceptableHandlingFormats.includes(4) && handlingFormats.includes(4)">駐車場受け取り</span>
            </div>
            <div class="l-menu-detail__info">
              <h1>{{ product.productName }}</h1>
              <p v-html="autolink(product.description)"></p>
              <div class="mb-8" v-if="type == 'pickup' && isPriceNoticeRequired(tenant)">
                <p>※軽減税率制度により「お持ち帰り」または「店内でお食事」にて税込価格表示が異なります </p>
              </div>
              <hr>
              <div class="d-flex justify-content-space align-items-center mb-41">
                <div class="c-list-menu__control--left" v-if="product && getProductPriceTaxed(product, type, tenant) > 0">
                  <div v-if="!product.sale" class="c-price-product">
                    {{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                  </div>
                  <div v-else class="c-price-product sale">
                    <span class="sale-original">{{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small></span><br />
                    <small>SALE：</small>{{ priceFormat(getProductSalePriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                  </div>
                </div>
                <div class="c-list-menu__control--right">
                  <div v-on:click="showOption(product.id)" :class="{'c-btn-add-cart': true, 'c-btn-reservation': type == 'reservation' }" v-if="!product.soldout">
                    {{type == 'reservation' ? '予約する' : 'カートに追加'}}
                  </div>
                  <div v-else class="c-btn-add-cart soldout">
                    SOLDOUT
                  </div>
                </div>
              </div>
              <div v-on:click="backPagePrevious" class="c-btn-back-list box-center">
                一覧へ戻る
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <!-- The Modal -->
        <div id="myModal" class="c-modal" :style="{display:'block', 'z-index': 150}">
          <div class="c-modal__dialog c-modal__dialog--center">
            <!-- Modal content -->
            <div class="c-modal__content">
              <div v-on:click="backPagePrevious" class="c-btn-close c-btn-close--circle c-modal__close" id="close_modal">
                <img src="/assets/images/icon/icon-close-black.svg" alt="">
              </div>
              <div class="l-order-info">
                <div class="mb-24">
                  <div class="l-order-info__title">{{ product.productName }}</div>
                  <div class="c-price-product c-price-product--normal" v-if="!product.sale && getProductPriceTaxed(product, type, tenant) > 0">
                    {{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                  </div>
                  <div v-else-if="getProductPriceTaxed(product, type, tenant) > 0" class="c-price-product sale">
                    <span class="sale-original">{{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small></span><br />
                    <small>SALE：</small>{{ priceFormat(getProductSalePriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                  </div>
                </div>
                <div v-for="(optionGroup, index) in productOptions" class="mb-24" :key="index" >
                  <div class="l-order-info__title l-order-info__title--sm">
                    {{ optionGroup.name }}
                    <small v-if="optionGroup.required" class="color-5">（必須）</small>
                    <small v-else>（任意）</small>
                  </div>
                  <ul v-if="optionGroup.multiple" class="c-list-order">
                    <li v-for="(option, index) in optionGroup.options" :key="index">
                      <div v-if="checkShowOption(option)" class="c-list-order__item">
                      <div class="c-list-order__info">
                        <label class="c-checkbox">
                          <input type="checkbox" :id="'checkbox_' + optionGroup.optionGroupOptionId + '_' + index" v-model="selectedCheckbox" :value="option" @change="optionChanged++">
                          <span class="c-checkbox__checkmark"></span>
                        </label>
                        <label :for="'checkbox_' + optionGroup.optionGroupOptionId + '_' + index" class="c-list-order__name">{{ option.optionName }}</label>
                      </div>
                      <div class="c-list-order__quantity" v-if="getPrice(product) > 0">{{ getOptionPrice(product,option) >= 0 ? '+' : '' }}{{ priceFormat(getOptionPriceTaxed(product, option, type, tenant)) }}円</div>
                      </div>
                    </li>
                  </ul>
                  <ul v-else class="c-list-order">
                    <li v-for="(option, index) in optionGroup.options" :key="index" >
                      <div v-if="checkShowOption(option)" class="c-list-order__item">
                      <div class="c-list-order__info">
                        <label class="c-radio">
                          <input type="radio" :name="optionGroup.optionGroupOptionId" :id="'radio_' + optionGroup.optionGroupOptionId + '_' + index" v-model="selectedRadio[optionGroup.optionGroupOptionId]"
                            :value="option" @change="optionChanged++">
                          <span class="c-radio__checkmark"></span>
                        </label>
                        <label :for="'radio_' + optionGroup.optionGroupOptionId + '_' + index" class="c-list-order__name">{{ option.optionName }}</label>
                      </div>
                      <div class="c-list-order__quantity" v-if="getPrice(product) > 0">{{ getOptionPrice(product,option) >= 0 ? '+' : '' }}{{ priceFormat(getOptionPriceTaxed(product, option, type, tenant)) }}円</div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="d-flex align-items-center justify-content-space l-order-info__number" v-if="tenant.enableTimebaseReservation && type == 'reservation'">
                  <span class="l-order-info__title pr-16">人数</span>
                  <div>
                    <div class="c-quantity">
                        <button class="c-quantity__btn" data-type="minus" @click.prevent="countNumberOfPeople(-1)" v-bind:disabled="reservationNumberOfPeople <= product.minNumberOfPeople">
                          <img src="/assets/images/icon/icon-minus.svg" alt="" />
                        </button>
                        <input
                          class="c-quantity__input"
                          type="text"
                          disabled
                          style="opacity: 1"
                          v-model="reservationNumberOfPeople"
                        />
                        <button class="c-quantity__btn" data-type="plus" @click.prevent="countNumberOfPeople(+1)" v-bind:disabled="reservationNumberOfPeople >= product.maxNumberOfPeople">
                          <img src="/assets/images/icon/icon-plus.svg" alt="" />
                        </button>
                      </div>
                  </div>
                </div>
                <div class="l-order-info__foot bt-none">
                  <h1>{{ product.productName }}<template v-if="totalPriceProduct > 0">（合計）</template></h1>
                  <div class="d-flex justify-content-space align-items-center">
                    <div class="c-list-menu__control--left" v-if="totalPriceProduct > 0">
                      <div v-if="!product.sale" class="c-price-product">
                        {{ priceFormat(totalPriceProduct) }}<small>円（税込）</small>
                      </div>
                      <div v-else class="c-price-product sale">
                        <span class="sale-original">{{ priceFormat(totalPriceProduct) }}<small>円（税込）</small></span><br />
                        <small>SALE：</small>{{ priceFormat(totalPriceProductSale) }}<small>円（税込）</small>
                      </div>
                    </div>
                    <div class="c-list-menu__control--right">
                      <div :class="{'c-btn-add-cart': true, 'c-btn-reservation': type == 'reservation','c-btn-large':tenant.enableTimebaseReservation  }" @click.prevent="addToCart">
                        {{type == 'reservation' ? tenant.enableTimebaseReservation ? '日時選択へ進む' : '予約する' : 'カートに追加'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer-cart></footer-cart>
      <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
        ></alert>
      <confirm-continue :show="showContinueDialog" :orderType="postItem"  />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import FooterCart from "../components/FooterCart.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getProvider, getProduct, getProductOptions, generateDocumentId, getMobileOrderConfig } from "../store/firestore";
import Swiper, { Pagination } from "swiper";
import dayjs from "dayjs";
import PopAlert from "../components/PopAlert.vue";
import ConfirmContinue from "../components/ConfirmContinue.vue";
const $ = window.$;

Swiper.use(Pagination);

export default Vue.extend({
  name: "MobileOrderOption",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'footer-cart': FooterCart,
    'alert': Alert,
    PopAlert,
    ConfirmContinue
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "MobileOrderCheckout" && this.type == 3) {
      return;
    }
    next();
  },
  mixins: [Tenant],
  async created() {
    this.tenantId = this.$route.params.id;
    this.type = this.$route.params.type;
    this.productId = this.$route.params.productId;
    this.mobileOrderConfig = await getMobileOrderConfig();
    const tenant = await getProvider(this.tenantId);
    const now = Date.now();
    const product = await getProduct(this.tenantId, this.productId, this.$store.state.userId);
    if(!product){
      await this.confirm("指定された商品がみつかりませんでした。", true);
      this.$router.push('/mobileorder');
      return;
    }
    let handlingFormats = this.getHandlingFormats(tenant, this.type);
    this.handlingFormats = handlingFormats;
    switch(this.type){
      case 'pickup': {
          if(tenant.pickupDiscloseAt > now){
            await this.confirm("現在モバイルオーダーを提供していません。モバイルオーダートップに戻ります。", true);
            this.$router.push('/mobileorder');
            return;
          }
          if ( tenant.handlingFormatToGo && tenant.handlingFormatToGo.enabled) {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 1);
            // name = "お持ち帰り";
          } else if ( tenant.handlingFormatForHere && tenant.handlingFormatForHere.enabled) {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 2);
            //name = "店内でお食事";
          }
          //this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 2);
          this.setting = tenant.pickUp;
          this.orderType = "モバイルオーダー";
          this.acceptableHandlingFormats = product.acceptableHandlingFormatForPickup || [];
          break;
        }
      case 'delivery':
      case 'drivethru':
      case 'parkandpickup': {
          if (this.type == 'drivethru') {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 3);
          } else {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 4);
          }
          const orderType = this.type == 'drivethru' ? 'ドライブスルー' : '駐車場受け取り';
          if(tenant.deliveryDiscloseAt > now){
            await this.confirm(`現在${orderType}を提供していません。モバイルオーダートップに戻ります。`, true);
            this.$router.push('/mobileorder');
            return;
          }
          this.setting = tenant.delivery;
          this.orderType = orderType;
          this.acceptableHandlingFormats = product.acceptableHandlingFormatForDelivery || [];
          break;
        }
      case 'reservation':
        this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 5);
        if(tenant.reservationDiscloseAt > now){
          await this.confirm(`現在${this.orderType}を提供していません。店舗トップに戻ります。`, true);
          this.$router.push('/shop/list?id='+this.tenantId);
          return;
        }
        this.setting = tenant.reservation;
        this.acceptableHandlingFormats = product.acceptableHandlingFormatForReservation || [];
        break;
      default:
        await this.confirm("不正なURLです。モバイルオーダートップに戻ります。", true);
        this.$router.push('/mobileorder');
        break;
    }
    const productOptions = await getProductOptions(this.tenantId, product);
    this.tenant = tenant;
    product.description = Common.addExtLink(product.description);
    this.product = product;
    const orderType = this.getOrderType();
    this.reservationNumberOfPeople = (orderType == 3) ? product.minNumberOfPeople : 1;
    this.totalPriceProduct = this.calcTotalPriceProduct();
    this.totalPriceProductSale = this.calcTotalPriceProduct(true);
    this.productOptions = productOptions;
    if (this.acceptableHandlingFormats.length == 0) {
      //エラー
      await this.confirm(`現在この商品は指定の提供方法で提供していません。店舗トップに戻ります。`, true);
      this.$router.push(`/mobileorder/shop/${this.tenantId}/${this.type}`);
      return;
    }
    productOptions.map(optionGroup => {
      if (!optionGroup.multiple) {
        this.selectedRadio[optionGroup.optionGroupId] = {};
      }
    })
    this.dataReady = true;
  },
  data() {
    return {
      tenant: undefined,
      type: undefined,
      product: undefined,
      dataReady: false,
      orderType: undefined,
      productOptions: undefined,
      totalPrice: undefined,
      selectedCheckbox: [],
      selectedRadio: {},
      setting: undefined,
      optionChanged: 0,
      totalPriceProduct: 0,
      totalPriceProductSale: 0,
      showContinueDialog: false,
      handlingFormats: [],
      acceptableHandlingFormats: [],
      mobileOrderConfig: null,
      baseHandlingFormatSetting: null,
      reservationNumberOfPeople:1,
      postItem: null,
      isConfirm: false
    }
  },
  mounted() {
    Common.initDom();
    // swiper banner
    var banner_swiper = new Swiper('.js-banner-swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })

  },
  watch: {
    optionChanged: function(value){
      this.totalPriceProduct = this.calcTotalPriceProduct();
      this.totalPriceProductSale = this.calcTotalPriceProduct(true);
    }
  },
  methods: {
    getPrice(product) {
      const handlingFormats = this.getHandlingFormatType(this.type, this.tenant);
      const taxRateType = this.getTaxRateType(handlingFormats.handlingFormatDef, handlingFormats.number == 2 ? 1 :2);
      let price = this.getUnitPrice(product, taxRateType, "excluded");
      return price ? price : 0;
    },
    getOptionPrice(product,option) {
      const handlingFormats = this.getHandlingFormatType(this.type, this.tenant);
      //お持ち帰りのみの場合は軽減税率優先
      const taxRateType = this.getTaxRateType(handlingFormats.handlingFormatDef, handlingFormats.number == 2 ? 1 :2);
      let price = this.getUnitOptionPrice(product,option, taxRateType, "excluded");
      return price ? price : 0;
    },
    showOption(productId) {
      this.$router.push(`/mobileorder/shop/${this.tenantId}/${this.type}/${productId}/option`);
    },
    countNumberOfPeople(val) {
      this.reservationNumberOfPeople = this.reservationNumberOfPeople + val;
    },
    calcTotalPriceProduct(useSale) {
      /*
      const handlingFormats = this.getHandlingFormatType(this.type, this.tenant);
      //お持ち帰りのみの場合は軽減税率優先
      const taxRateType = this.baseHandlingFormatSetting.taxRate ? this.baseHandlingFormatSetting.taxRate :this.getTaxRateType(handlingFormats.handlingFormatDef, handlingFormats.number == 1 ? 1 : 2);
      */
      let handlingFormat = this.getProductBaseHandlingFormatSetting(this.product, this.type, this.tenant);
      let taxRateType = this.getTaxRateType(handlingFormat, 1);
      let p = 0;
      if (useSale) {
        p = this.getProductPrice(this.product,taxRateType,"sale");
      } else {
        p = this.getProductPrice(this.product,taxRateType);
      }
      const pricesCheckbox = this.selectedCheckbox.map(i => this.getUnitOptionPrice(this.product,i,taxRateType))
      if (pricesCheckbox.length > 0) {
        p += pricesCheckbox.reduce((i, j) => i + j)
      }
      var selectedRadioValues = Object.values(this.selectedRadio);
      for(var i=0; i<selectedRadioValues.length; i++){
        const selectedRadio = selectedRadioValues[i];
        const selectedRadioPrice = this.getUnitOptionPrice(this.product,selectedRadio,taxRateType);
        if (selectedRadio && selectedRadioPrice != undefined && !isNaN(selectedRadioPrice)) {
          p += selectedRadioPrice;
        }
      }
      let defaultRate = 1;
      /*
      let handlingFormat = this.baseHandlingFormatSetting;
      //モバイルオーダーでイートイン対応の商品の場合、通常税率をデフォルトにする
      if (this.type == 'pickup' && this.product.acceptableHandlingFormatForPickup.indexOf(2) != -1) {
        defaultRate = 2;
      } else if (this.type == 'pickup' && this.product.acceptableHandlingFormatForPickup.indexOf(2) == -1) {
        handlingFormat = null;
      }
      let taxRate = this.getDefaultTaxRate(this.product, handlingFormat, defaultRate);
      */
      let taxRate = this.getDefaultTaxRate(this.product, handlingFormat, defaultRate);
      return (this.product.taxCalculation == 2) ? p : Math.trunc(p * (100 + parseInt(taxRate)) / 100);
    },
    async addToCart() {
      //認証状態チェック
      if(!this.isUserOrderable()){
        await this.confirm("モバイルオーダーのご利用にはログイン・本人確認が必要です。", true);
        return;
      }

      const now = Date.now();
      if(!this.isInService()){
        await this.confirm("現在注文を受け付けられません。", true);
        return;
      }

      if (this.product.soldout) {
        await this.confirm(`${this.product.productName}は現在売り切れのためご注文いただけません。`, true);
        return;
      }

      if (this.isConfirm) return false;
      this.isConfirm = true; 

      //軽減税率か通常税率かを取得する
      const handlingFormats = this.getHandlingFormatType(this.type, this.tenant);
      const taxRateType = this.getTaxRateType(handlingFormats.handlingFormatDef, handlingFormats.number == 2 ? 2 : 1);
      //this.product

      //オプションバリデーション
      let isValid = true;
      let optionsSelected = [];
      for(var i=0; i<this.productOptions.length; i++){
        const option = this.productOptions[i];
        const optionGroupOptionId = option.optionGroupOptionId;
        const optionGroupId = option.optionGroupId;
        if (option.multiple) {
          const selected = this.selectedCheckbox.filter(item => { return item.optionGroupOptionId == optionGroupOptionId });
          if (option.required && !selected) {
            this.isConfirm = false; 
            await this.confirm(`${option.name}が選択されていません。`, true);
            return
          } else if (selected) {
            selected.map(item => {
              let price = this.getUnitOptionPrice(this.product,item, taxRateType,"excluded");
              let inTax = {};
              if (this.product.taxCalculation == 2) {
                inTax = {
                  priceIncluded1:item.priceIncluded1,
                  priceIncluded2:item.priceIncluded2,
                  taxAmount1:item.taxAmount1,
                  taxAmount2:item.taxAmount2,
                  taxRateType:taxRateType,
                  taxAmount: this.getUnitOptionInTax(item, taxRateType)
                }
              } 

              optionsSelected.push({
                optionId: item.optionId,
                optionGroupOptionId: optionGroupOptionId,
                optionGroupId: optionGroupId,
                optionGroupName: option.name,
                optionName: item.optionName,
                price: price,
                requiredTime:(item.requiredTime) ? item.requiredTime : 0,
                ...inTax
              });
            })
          }
        } else {
          const selected = this.selectedRadio[optionGroupOptionId];
          if (option.required && !selected) {
            this.isConfirm = false;
            await this.confirm(`${option.name}が選択されていません。`, true);
            return
          } else if (selected) {
            let price = this.getUnitOptionPrice(this.product,selected, taxRateType,"excluded");
            //オプションの税抜き金額挿入
            let inTax = {};
            if (this.product.taxCalculation == 2) {
              inTax = {
                priceIncluded1:selected.priceIncluded1,
                priceIncluded2:selected.priceIncluded2,
                taxAmount1:selected.taxAmount1,
                taxAmount2:selected.taxAmount2,
                taxRateType:taxRateType,
                taxAmount: this.getUnitOptionInTax(selected, taxRateType)
              }
            } 
            optionsSelected.push({
              optionId: selected.optionId,
              optionGroupOptionId: optionGroupOptionId,
              optionGroupId: optionGroupId,
              optionGroupName: option.name,
              optionName: selected.optionName,
              price: price,
              requiredTime:(selected.requiredTime) ? selected.requiredTime : 0,
              ...inTax
            });
          }
        }
      }

      const cart = this.$store.state.cart || {};
      const orderKey = `${this.tenantId}_${this.type}`;
      const cartId = this.$store.state.cartId || this.generateOrderId();
      const orderType = this.getOrderType();

      if (!cart[orderKey]) {
        const orderId = this.generateOrderId();
        cart[orderKey] = {
          orderType: orderType,
          userId: this.$store.state.userId,
          tenantId: this.tenantId,
          orderGroupId: cartId,
          orderId: orderId,
          receiveDate: null,
          totalAmount: 0,
          priceAmount: 0,
          discountAmount: 0,
          taxAmount: 0,
          comissionFee: 0,
          comissionTaxRate: 10,
          orderProducts: [],
          deliveryPlace: "",
          deliveryPlaceDetail: {}
        }
        if (this.type == 'reservation') {
          const handlingFormatSetting = this.tenant?.handlingFormatReservation; 
          cart[orderKey].handlingFormat = 5;
          cart[orderKey].handlingFormatSetting = handlingFormatSetting;
          cart[orderKey].deliveryPlace = "ご来店予約";
        }
      }

      if (this.type == 'pickup') {
        const getAvailableHandlingFormats = this.getAvailableHandlingFormats(cart[orderKey], this.tenant);
        const productHandlingFormats = this.acceptableHandlingFormats;
        const intersects = getAvailableHandlingFormats.filter(f => productHandlingFormats?.indexOf(f) != -1);
        if (intersects.length == 0){
          //Not able to add to cart
          const handlingFormatName = this.getHandlingFormatName(productHandlingFormats[0]);
          await this.confirm(`この商品は${handlingFormatName}のみのご提供となりますが、カート内にこの方式に対応できない商品が含まれているため、カートに追加できません。`, true);
        } else if (getAvailableHandlingFormats.length < productHandlingFormats.length){
          //Less availability of cart
          const handlingFormatName = this.getHandlingFormatName(intersects[0]);
          const result = await this.confirm(`すでに${handlingFormatName}のみの商品がカートに入っているため、こちらの商品についても${handlingFormatName}となりますがよろしいですか？`);
          if (!result) {
            this.isConfirm = false;
            return;
          }
        } else if (productHandlingFormats.length < getAvailableHandlingFormats.length) {
          //Less availability of product
          const handlingFormatName = this.getHandlingFormatName(intersects[0]);
          const result = await this.confirm(`こちらの商品は${handlingFormatName}のみのご提供となるため、こちらの商品をカートに入れますとすべて${handlingFormatName}となりますがよろしいですか？`);
          if (!result) {
            this.isConfirm = false;
            return;
          }
        }
        cart[orderKey].handlingFormat = intersects[0];
        cart[orderKey].handlingFormatSetting = this.getHandlingFormatSetting(this.tenant, intersects[0]);
      } else {
        if (this.type == 'drivethru') {
          cart[orderKey].handlingFormat = 3;
          cart[orderKey].handlingFormatSetting = this.getHandlingFormatSetting(this.tenant, 3);
        } else if (this.type == 'parkandpickup') {
          cart[orderKey].handlingFormat = 4;
          cart[orderKey].handlingFormatSetting = this.getHandlingFormatSetting(this.tenant, 4);
        } else if (this.type == 'reservation') {
          cart[orderKey].handlingFormat = 5;
          cart[orderKey].handlingFormatSetting = this.getHandlingFormatSetting(this.tenant, 5);
        }
      }

      // 人数
      cart[orderKey].reservationNumberOfPeople = this.reservationNumberOfPeople;
      const sameProduct = cart[orderKey].orderProducts.find(item => {
        return item.productId == this.productId && optionsSelected.filter(opt => {
          const sameOpt = item.options.find(o => o.optionId == opt.optionId && o.optionGroupOptionId == opt.optionGroupOptionId);
          return sameOpt != null
        }).length == optionsSelected.length 
        && optionsSelected.length == item.options.length
      })
      
      if (sameProduct) {
        sameProduct.quantity++;
        sameProduct.tmpQuantity++;
      } else {
        let price = 0;
        let inTax = {}
        //税抜き金額を挿入
        if (this.product.taxCalculation == 2) {
          price = this.getProductSalePriceInTax(this.product, taxRateType);
          //内税用の値
          inTax = {
            priceIncluded1:this.product.priceIncluded1,
            priceIncluded2:this.product.priceIncluded2,
            taxAmount1:this.product.taxAmount1,
            taxAmount2:this.product.taxAmount2,
            taxRateType:taxRateType,
            taxAmount: this.getProductInTax(this.product, taxRateType)
          }
        } else {
          price = this.getProductPrice(this.product, taxRateType,"sale");
        }
        
        cart[orderKey].orderProducts.push({
          productId: this.productId,
          productName: this.product.productName,
          image: this.product.image && this.product.image[0],
          quantity: 1,
          tmpQuantity: 1,
          price: price,
          taxRate1: parseInt(this.product.taxRate1),
          taxRate2: parseInt(this.product.taxRate2),
          acceptableHandlingFormatForPickup: this.product.acceptableHandlingFormatForPickup,
          acceptableHandlingFormatForDelivery: this.product.acceptableHandlingFormatForDelivery,
          options: optionsSelected,
          requiredTime : (this.product.requiredTime) ? this.product.requiredTime : 0, //所要時間
          taxCalculation:parseInt(this.product.taxCalculation),
          ...inTax
        })
        
      }
      this.$store.dispatch('updateCart', { cartData: cart, })
      .then(() => {
        if (this.type == 'reservation') {
          //来店予約は直接チェックアウトへ
          this.$router.push('/mobileorder/checkout');
        } else {
          let type = null;
          switch(cart[orderKey].handlingFormat){
            case 1:
            case 2: 
              type = 'pickup';
              break;
            case 3:
              type = 'drivethru';
              break;
            case 4: 
              type = 'parkandpickup';
              break;
            case 5:
              type = 'reservation';
              break;
            default:
            break;
          }
          this.postItem = {
            type:type,
            tenant:this.tenant.id
          };
          this.showContinueDialog = true;
          this.isConfirm = false;
        }
      })
      .catch(err => {
        this.isConfirm = false;
        if (err.code == "invalid-cart-item") {
          this.$router.push('/mobileorder/cart');
          return;
        }
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
    },
    getOrderType(){
      switch(this.type){
        case 'pickup':
          return 1;
        case 'delivery':
        case 'drivethru':
        case 'parkandpickup':
          return 2;
        case 'reservation':
          return 3;
        default:
          //nothing
      }
    },
    generateOrderId() {
      return generateDocumentId();
    },
    checkShowOption(product) {  

      if (this.type == 'reservation') {
      //有料来店予約対応
      //商品を出さないとき
      //paidReservationEnabledがtrueの場合
        if (!this.tenant.paidReservationEnabled && this.getPrice(product) > 0) {
        //ReservationEnabledがtrueのときだけ金額がある商品を表示
        //時間指定予約じゃない場合も出さない
          return false;
        }
      }
      return true;
    },
    isInService() {
      const nowH = parseInt(dayjs().format("H"));
      
      //日時指定予約の場合処理を通す
      //モバイルオーダー
      if (this.getOrderType() == 1 && this.tenant.enableTimebasePickup) {
        return true;
      }
      //来店予約
      if (this.getOrderType() == 3 && this.tenant.enableTimebaseReservation) {
        return true;
      }

      return this.setting.timeInService.includes(nowH);
    },
    isPriceNoticeRequired(tenant){
      //「商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わります」
      return tenant && tenant.shopCategoryType == 5 
        && tenant?.handlingFormatToGo?.enabled 
        && tenant?.handlingFormatForHere?.enabled;
    },
  }
});
</script>